import { render, staticRenderFns } from "./TemplateLayout.vue?vue&type=template&id=3e38835c&scoped=true"
import script from "./TemplateLayout.vue?vue&type=script&lang=js"
export * from "./TemplateLayout.vue?vue&type=script&lang=js"
import style0 from "./TemplateLayout.vue?vue&type=style&index=0&id=3e38835c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38835c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e38835c')) {
      api.createRecord('3e38835c', component.options)
    } else {
      api.reload('3e38835c', component.options)
    }
    module.hot.accept("./TemplateLayout.vue?vue&type=template&id=3e38835c&scoped=true", function () {
      api.rerender('3e38835c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/TemplateLayout.vue"
export default component.exports